import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";

async function _onCopiedFrameLoad(val, e) {
	const $replace = $(e.target);
	const wndw = e.target.contentWindow;
	wndw.document.title = $replace.attr("name");
	
	const $body =  $(wndw.document.body).css({
		"margin": 0,
		"overflow": "hidden",
		"padding": 0
	}).addClass(`${document.body.className} is-ready`);
	
	$body.parent().css("min-width", this.app.browser[0] === "ie" ? "auto" : "initial");
	
	const $editorContainer = $("<div/>");
	
	const $box = $("<div/>").addClass(`${this.boxClass} in-frame`).attr({
		"data-theme": this.theme
	}).append($editorContainer).appendTo($body);
	
	const quill = new this.Quill($editorContainer.get(0), {
		modules: {
			toolbar: false
		},
		readOnly: true,
		theme: this.theme
	});
	
	quill.setContents(val);
	
	delete this.app._imports[wndw.name];
	
	const styleSheet = this.get("frame").styleSheet;
	
	await Promise.all([
		// スタイルシートの設定
		!!styleSheet && new Promise((resolve, reject) => this.app.require(styleSheet, {
			doc: wndw.document,
			type: "stylesheet",
			success: resolve,
			error: reject
		})),
		
		// import plugin's css
		this._importPluginStyleSheet(wndw),
		
		// 画像の読み込み完了を検出
		Promise.all(
			u_.getAsArray( $editorContainer.find("img") ).map(img => new Promise(resolve => {
				img.onload = resolve;
				img.onerror = resolve;
				img.complete && $(img).trigger(!img.height ? "error" : "load", [true]);
			}))
		)
	]);
	
	// * for jQuery - firefox bug
	$box.get(0).offsetHeight;
	
	$replace.height( Math.ceil( $box.outerHeight(true) ) );
	if(this.theme === "snow") {
		// * for jQuery - firefox bug
		$replace.get(0).offsetHeight;
		
		$editorContainer.outerHeight( Math.floor( $replace.height() ) );
	}
	
	// * for jQuery - firefox bug
	$editorContainer.get(0).clientWidth;
	
	$replace.width("").width( Math.ceil( $editorContainer.outerWidth(true) ) );
}

export default _onCopiedFrameLoad;
